import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FaChevronLeft, FaPencilAlt } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import { Box, Button, Grid } from '@mui/material'
import { AppDispatch } from 'redux/store'
import { usePOST_gradeAcademicPeriodMutation, usePOST_gradeFinalMutation } from 'redux/api/finalGradesApi'
import { Form, Formik } from 'formik'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import InputField from 'components/atoms/fields/InputField'
import formModel, { initialValues, validationSchema } from 'utils/formModels/groupCourseGradeCourseComponentModel'
import { crudColorMap, crudIconMap}  from 'utils/helpers'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import {  IFinalGradeData } from 'types'
import { setGradePopupData } from 'redux/ui/groupCourseGradebookUI'

interface IProps {
  gradePopupData: any
  viewOnly?: boolean
}

const GroupCourseGradeFinalForm: FC<IProps> = ({ gradePopupData, viewOnly=false }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  
  const action = 'edit';

  const [gradeAcademicPeriod, {isLoading: isLoadingAcademicPeriod, error: errorAcademicPeriod, isSuccess: isSuccessAcademicPeriod}] = usePOST_gradeAcademicPeriodMutation()
  const [gradeFinal, {isLoading: isLoadingFinal, error: errorFinal, isSuccess: isSuccessFinal}] = usePOST_gradeFinalMutation()
  useErrorAlert(errorAcademicPeriod || errorFinal)
  const isLoading = isLoadingAcademicPeriod || isLoadingFinal
  const isSuccess = isSuccessAcademicPeriod || isSuccessFinal

  useEffect(() => {
    if (isSuccess) {
      dispatch(setGradePopupData(null))
    }
  }, [isSuccess])

  const { grade_percentage, comment } = formModel()

  const formValues = { 
    ...initialValues,
    grade_percentage: gradePopupData.grade_percentage ?? '' 
  }

  
  return (
    <>
    {
        <Formik
          enableReinitialize
          initialValues={formValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {

            if(gradePopupData.type === 'term'){
              const data: IFinalGradeData = {
                student: gradePopupData.student_id,
                group_course_id: gradePopupData.group_course_id,
                academic_year: gradePopupData.academic_year,
                academic_period: gradePopupData.academic_period_id,
                grade_percentage: values.grade_percentage,
                comment: values.comment
              }
              gradeAcademicPeriod({id: gradePopupData.group_course_id, body: data});
            }
            else if(gradePopupData.type === 'final'){
              const data: IFinalGradeData = {
                student: gradePopupData.student_id,
                group_course_id: gradePopupData.group_course_id,
                academic_year: gradePopupData.academic_year,
                grade_percentage: values.grade_percentage,
                comment: values.comment
              }   
              gradeFinal({id: gradePopupData.group_course_id, body: data});
            }
            
          }}
        >
          <Form>

            {/* <div>{t('common.course')}:  <b>{gradePopupData.course_title}</b></div> */}
            <div>{t('common.student')}:  <b>{gradePopupData.student_name}</b></div>

            { gradePopupData.type == 'term' && <div>{t('common.academic-period')}: <b>{gradePopupData.academic_period_title}</b></div> }
            { gradePopupData.type == 'final' && <div><FaPencilAlt /> <b>{t('common.final-grade')}</b></div> }

      
            <Grid container spacing={2} sx={{ marginTop: '1rem' }}>
              <Grid item xs={12} lg={3}>
                <InputField fieldProps={{ ...grade_percentage }} disabled={viewOnly}/>
              </Grid>
              <Grid item xs={12} lg={9}>
                <InputField multiline={true} fieldProps={{ ...comment }} disabled={viewOnly} />
              </Grid>
              
              <Grid item xs={12}>
                <Box sx={{ display: 'flex' }}>
                  <Button
                    variant='outlined'
                    color='black'
                    onClick={() => {
                        dispatch(setGradePopupData(null))
                      }
                    }
                    sx={{ minHeight: '2.5rem', width: '10rem' }}
                  >
                    <FaChevronLeft style={{ fontSize: '1.1rem', margin: '-3px 0.5rem 0 -0.5rem' }} />
                    {`${t('common.back')}`}
                  </Button>
                  {!viewOnly && (
                    <SubmitButton
                      color={crudColorMap[action]}
                      text={`${t('form-actions.' + action)}`}
                      icon={crudIconMap[action]}
                      sx={{ width: '10rem' }}
                      isLoading={isLoading}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Form>
        </Formik>
      }
      </>
  )
}
export default GroupCourseGradeFinalForm
